import {
  ADD_LEAVE_STATUS_FAIL,
  ADD_LEAVE_STATUS_SUCCESS,
  ADD_LEAVE_STATUS_REQUEST,
  DELETE_LEAVE_STATUS_REQUEST,
  DELETE_LEAVE_STATUS_SUCCESS,
  GETDETAIL_LEAVE_STATUS_REQUEST,
  GETDETAIL_LEAVE_STATUS_FAIL,
  GETDETAIL_LEAVE_STATUS_SUCCESS,
  UPDATE_LEAVE_STATUS_FAIL,
  UPDATE_LEAVE_STATUS_SUCCESS,
  UPDATE_LEAVE_STATUS_REQUEST,
  DELETE_LEAVE_STATUS_FAIL,
  GETALL_LEAVE_STATUS_FAIL,
  GETALL_LEAVE_STATUS_SUCCESS,
  GETALL_LEAVE_STATUS_REQUEST,
  CLEAR_LEAVE_STATUS_RECORD,
} from "../constant/LeaveStatusConstant";

const initialState = {
  loading: false,
  action: "Leave status",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const LeavestatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_LEAVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_LEAVE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GETDETAIL_LEAVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_LEAVE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_LEAVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_LEAVE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_LEAVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_LEAVE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case DELETE_LEAVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_LEAVE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case CLEAR_LEAVE_STATUS_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default LeavestatusReducer;
